import { createAction } from '@ngrx/store';

export const logout = createAction('[App Logout] Logout');

export type AppActionsUnion = ReturnType<typeof logout>;
